import React, { FC } from 'react';

import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Route, Switch } from 'react-router-dom';

import { LearnerInfo, USER_ROLES } from '../../../../types';
import { getTeamsWhereLearner } from '../../../../utils/helpers';
import AllTeamView from '../../components/AllTeamView';
import InviteLearnerView from '../../components/InviteLearnerView';
import LearnerTeamView from '../../components/LearnerTeamView';
import SingleTeamView from '../../components/SingleTeamView';
import { MY_ACCOUNT_LINKS } from '../const';
import useStyles from './styles';

interface MyTeamsPageProps {
  userInfo: LearnerInfo;
  tenantTitle?: string | null;
}

const MyTeamsPage: FC<MyTeamsPageProps> = ({ userInfo, tenantTitle }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const isOwner = userInfo?.role === USER_ROLES?.CompanyOwner;
  const isManager = userInfo?.role === USER_ROLES?.TeamManager;
  const isLearner = userInfo?.role === USER_ROLES?.B2BLearner;
  const teams = isLearner && getTeamsWhereLearner(userInfo?.teams || []);

  return (
    <div className={classes.container}>
      <Helmet>
        <title>
          {t('page.account.myTeams')} - {tenantTitle}
        </title>
      </Helmet>
      <Switch>
        <Route
          exact
          path={MY_ACCOUNT_LINKS.MyTeams}
          render={(props) =>
            isLearner ? (
              <LearnerTeamView teams={teams} {...props} />
            ) : (
              <AllTeamView {...props} ownerId={userInfo?.company?.owner_id} isOwner={isOwner} />
            )
          }
        />
        {(isOwner || isManager) && (
          <>
            <Route
              path={`${MY_ACCOUNT_LINKS.MyTeams}/:id/invite`}
              render={(props) => <InviteLearnerView {...props} />}
            />
            <Route
              exact
              path={`${MY_ACCOUNT_LINKS.MyTeams}/:id`}
              render={(props) => (
                <SingleTeamView
                  {...props}
                  isOwner={isOwner}
                  isManager={isManager}
                  companyName={userInfo?.company?.name}
                />
              )}
            />
          </>
        )}
      </Switch>
    </div>
  );
};

export default MyTeamsPage;
